import type {EventHandler, EventType, VehicleFoundEvent} from "../index";
import store from "../../../configureStore";
import {VEHICLE} from "../../action";

export const VehicleFoundEventHandler: EventHandler = {
	handles(eventType: EventType): boolean {
		return eventType === "VEHICLE_FOUND";
	},
	handle(event: VehicleFoundEvent) {
		store.dispatch({
			type: VEHICLE.FOUND,
			payload: event
		});
	}
};
